import { ISelectOption } from '../dynamic-forms/models/select-option';
import { ISelectOptionGroup } from '../dynamic-forms/models/select-option-group';

export class SelectHelpers {
  static toSelectList<T>(
    array: Array<T>,
    nameSelector: (this: T[], x: T) => string,
    valueSelector: (this: T[], x: T) => any,
    sortSelector?: (this: T[], x: T) => any,
    isDisabledSelector?: (this: T[], x: T) => any,
  ): ISelectOptionGroup[] {
    return SelectHelpers.toGroupedSelectList(
      array,
      () => '',
      nameSelector,
      valueSelector,
      sortSelector,
      isDisabledSelector,
    );
  }

  static toGroupedSelectList<T>(
    array: Array<T>,
    groupSelector: (value: any) => string,
    nameSelector: (this: T[], x: T) => string,
    valueSelector: (this: T[], x: T) => any,
    sortSelector?: (this: T[], x: T) => any,
    isDisabledSelector?: (this: T[], x: T) => any,
  ): ISelectOptionGroup[] {
    if (!sortSelector) {
      sortSelector = nameSelector;
    }

    const options = array
      .sort((a, b) => {
        let aValue = sortSelector.apply(null, [a]);
        let bValue = sortSelector.apply(null, [b]);

        if (aValue != null && typeof aValue == 'string') {
          aValue = aValue?.toString().trim().toLowerCase();
        }

        if (bValue != null && typeof bValue == 'string') {
          bValue = bValue?.toString().trim().toLowerCase();
        }

        return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
      })
      .map(
        item =>
          <ISelectOption>{
            group: groupSelector.apply(null, [item]),
            name: nameSelector.apply(null, [item]),
            value: valueSelector.apply(null, [item]),
            data: item,
            sortOrder: 1,
            isDeleted: false,
            isDisabled: isDisabledSelector?.apply(null, [item]) || false,
          },
      );

    const groups = Array.from(new Set(options.map((item: any) => item.group)));
    const optionGroups = groups.sort().map(
      item =>
        <ISelectOptionGroup>{
          name: item,
          sortOrder: 1,
          options: options.filter((opt: any) => opt.group === item),
        },
    );

    return optionGroups;
  }
}
